import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { getOffset } from '../helpers/functions';
import { baseElements } from '../helpers/constants';
gsap.registerPlugin(ScrollToPlugin);
class Anchor {
  constructor() {
    this.$header = baseElements.$header;
    this.inPageNav = document.querySelector('.frame-type-sticky_inpage_nav');
    this.anchorLinks = document.querySelectorAll('main a[href^="#"]');
  }
  initializeAnchorLink(hrefLink) {
    const targetSection = document.querySelector(hrefLink);
    if (!targetSection) return;
    const inPageNavHeight = this.inPageNav ? this.inPageNav.offsetHeight : 0;
    const navHeight = this.$header.offsetHeight;
    let position = getOffset(document.querySelector(hrefLink)).top;
    if (this.inPageNav) {
      const st = window.pageYOffset || document.documentElement.scrollTop;
      if (st < position) {
        position -= inPageNavHeight;
      } else {
        position -= inPageNavHeight + navHeight;
      }
    }
    window.history.pushState(null, null, hrefLink);
    gsap.to(window, {
      duration: 2,
      scrollTo: {
        y: position,
        offsetY: 50
      }
    });
  }
  scrollToSection() {
    this.anchorLinks.forEach(anchorLink => {
      anchorLink.addEventListener('click', event => {
        event.preventDefault();
        this.initializeAnchorLink(anchorLink.getAttribute('href'));
      });
    });
    if (window.location.hash) {
      this.initializeAnchorLink(window.location.hash);
    }
  }
  init() {
    document.addEventListener('DOMContentLoaded', this.scrollToSection.bind(this));
  }
}
const initAnchor = () => new Anchor().init();
export default initAnchor;